import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowSidebar } from '../../store/layoutSlice';
// import { RxHamburgerMenu } from "react-icons/rx";
import { Heading } from '@jobber/components/Heading';
import { useAuth } from '../../hooks/use-auth';
import { IoIosLogOut, IoMdArrowRoundForward, IoMdArrowRoundBack } from 'react-icons/io';
import ActivityLog from '../ActivityLog/ActivityLog';
import Sync from '../Sync/Sync';
import jobberLogo from '../../assets/logo.svg';
import { Button } from '@jobber/components/Button';

function Header() {
	const { logout } = useAuth()
	const dispatch = useDispatch();
	const layout = useSelector((store) => store.layout);
	const menuClickHandler = () => {
		dispatch(setShowSidebar(!layout.showSidebar));
	};
	return (
		<>
			<header className="header body-pd" id="header">
				<div className="header_toggle d-flex gap-2" onClick={menuClickHandler}>
					{layout.showSidebar ? <IoMdArrowRoundBack /> : <IoMdArrowRoundForward />}
					<Heading level={3}>{'The Royal Gateway'}</Heading>
				</div>
				<div className="header_img pointer">
					<div className="d-flex gap-3">
						<Button external url='https://secure.getjobber.com/home' label={
							<img src={jobberLogo} height={20} alt="jobber logo" />
						} />
						<Sync />
						<ActivityLog />
						<IoIosLogOut className="fs-2" onClick={logout} />
					</div>
				</div>
			</header>
		</>
	);
}

export default Header;
